import { Injectable } from "@angular/core";
import { AwsRum, AwsRumConfig } from "aws-rum-web";
import cookie from "cookie";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class CloudwatchService {
  private readonly config: AwsRumConfig = {
    signing: false, // IMPORTANT ; NE PAS SUPPRIMER CETTE LIGNE
    sessionSampleRate: 1,
    endpoint: "https://dataplane.rum.eu-west-3.amazonaws.com",
    telemetries: ["performance", "errors", "http"],
    allowCookies: true,
    enableXRay: false
  };

  private awsRum: AwsRum;

  init() {
    try {
      // https://github.com/aws-observability/aws-rum-web/blob/main/docs/configuration.md
      this.awsRum = new AwsRum(environment.cloudwatchLogsAppId, "1.0.0", "eu-west-3", this.config);
    } catch (error) {
      console.error(error);
      // Ignore errors thrown during CloudWatch RUM web client initialization
    }
  }

  addError(e: unknown) {
    this.awsRum.recordError(e);
  }

  /**
   * On récupère la session de cloudwatch RUM
   * On peut ainsi l'injecter dans le token de simulation
   * @return string
   */
  static getSession(): string {
    const cookies: any = cookie.parse(document.cookie);
    if (cookies.cwr_s) {
      const session: any = JSON.parse(atob(cookies.cwr_s));
      if (session.sessionId) {
        return session.sessionId;
      }
    }

    return `auto-${Date.now().toString(36)}`;
  }
}
